import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Home",
        link: "#home",
        },
        {
        title: "About",
        link: "#about",
        },
        {
        title: "Features",
        link: `#features`,
        },
        {
        title: "Roadmap",
        link: "#roadmap",
        },
        {
          title: "Tokenomics",
          link: "#tokenomics",
          },
    ];
  return (
    <Container maxWidth="xxl" style={{ position:"fixed",zIndex:"1",padding:"0 !important" , background:"#050c24e0"}}>
    <Container>
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </Container>
    </Container>
  )
}

export default LockerMenu